import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { CerrixSlideOutComponent } from "../cerrix-slide-out/cerrix-slide-out.component";
import { CommonModule } from "@angular/common";
import { CerrixSlideOutEditItemMenuItems } from "./models/cerrix-slide-out-edit-item-menu-items.model";

@Component({
    selector: "app-cerrix-slide-out-edit-item",
    templateUrl: "./cerrix-slide-out-edit-item.component.html",
    styleUrls: ["./cerrix-slide-out-edit-item.component.scss"],
    imports: [
        CommonModule,
        CerrixSlideOutComponent
    ],
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class.open]": "isOpen",
    },
})
export class CerrixSlideOutEditItemComponent {
    @Input() isOpen: boolean = false;
    @Input() items: CerrixSlideOutEditItemMenuItems;
    @Input() title: string;
    @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() itemsChange: EventEmitter<CerrixSlideOutEditItemMenuItems> =
        new EventEmitter<CerrixSlideOutEditItemMenuItems>();
    @Output() sectionChanged: EventEmitter<void> = new EventEmitter<void>();

    protected close(): void {
        if (!this.items?.items?.length) {
            this.isOpenChange.emit(false);
            return;
        }
        this.itemsChange.emit({ ...this.items, activeItem: this.items.items[0].id });
        this.isOpenChange.emit(false);
    }

    protected openSection(section: string): void {
        this.itemsChange.emit({ ...this.items, activeItem: section });
        this.sectionChanged.emit();
    }
}
